/*
 * Copyright (C) 2020 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as fromStaticData from 'app/static-data/store/static-data.selectors';
import { NamedValue } from 'app/shared/models';
import { State } from 'app/main/store';
import { filterUndefined } from 'app/shared/rxjs/rxjs.utils';
import { CommittableData } from 'app/page-modules/tenant-management/store/models';

@Component({
  selector: 'og-shared-config-editor',
  templateUrl: './shared-config-editor.component.html',
  styleUrls: ['./shared-config-editor.component.scss'],
  standalone: false
})
export class SharedConfigEditorComponent implements OnInit {
  readonly editorOptions = {
    theme: 'vs-dark',
    language: 'json',
    // Allows us to use the editor in Material Tabs:
    // https://github.com/atularen/ngx-monaco-editor/issues/19#issuecomment-354721120
    automaticLayout: true
  };

  readonly defaultEditorOptions = {
    ...this.editorOptions,
    readOnly: true
  };

  @Input() selectedConfigType: string | undefined;

  // Current value
  @Input() selectedConfigValueData: CommittableData<string> | undefined;
  @Input() isSelectedConfigValueLoading: boolean;
  @Input() selectedConfigValueError: string | undefined;

  // Default value
  @Input() showDefaultValueTab = false;
  @Input() selectedConfigDefaultValueData: string | undefined;
  @Input() isSelectedConfigDefaultValueLoading: boolean;
  @Input() selectedConfigDefaultValueError: string | undefined;

  @Output() configTypeChange = new EventEmitter<string>();
  @Output() configValueChange = new EventEmitter<string>();

  configTypes$: Observable<NamedValue<string>[]>;

  constructor(private store: Store<State>) {}

  ngOnInit(): void {
    this.configTypes$ = this.store.pipe(
      select(fromStaticData.getConfigTypeData),
      filterUndefined()
    );
  }
}
